import axios from "axios"
import store from "@/store"
import i18n from "@/locale/index"
import { Message } from "element-ui"
import { getToken } from "@/utils/token"
let loadingCount = 0

const service = axios.create({
  headers: { "Content-Type": "application/json" },
  timeout: 2 * 60 * 1000,

  withCredentials: true,
  baseURL: ""
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      if (config.data instanceof FormData) {
        config.data.append("token", token)
      } else if (config.data) {
        config.data = { ...config.data, token }
      } else {
        config.data = { token }
      }
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data"
    }

    const loading = !(config.loading === false || config.loading === 0)
    config.showLoading = loading

    if (loading) {
      loadingCount++
      const isLoading = store.state.app.isLoading
      if (loadingCount === 1 && !isLoading) store.dispatch("app/showLoading")
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    clearLoading(response.config)

    const res = response.data
    // 访问设备掉线后的处理
    // if (handleOfflineProcess(res)) {
    // 	return res
    // }

    if (res.status !== 0) {
      return handleBusinessError(res)
    }

    return res
  },
  error => {
    clearLoading(error.config)

    if (error.response) {
      return handleHttpError(error.response)
    }
    handleNetworkError(error)
    return Promise.reject(error)
  }
)

const clearLoading = config => {
  if (config?.showLoading) {
    loadingCount--
    if (loadingCount === 0) {
      store.dispatch("app/clearLoading")
    }
  }
}

// TODO
// 错误处理函数
const handleHttpError = response => {
  const msgMap = {
    400: i18n.t("index").msg.RequestError, //"请求错误",
    401: i18n.t("index").msg.LoginExpired, //"登录过期，请重新登录",
    403: i18n.t("index").msg.AccessDenied, // "拒绝访问",
    404: i18n.t("index").msg.ResourceNotExist, //"请求资源不存在",
    500: i18n.t("index").msg.ServerError, // "服务器错误",
    502: i18n.t("index").msg.GatewayError, //"网关错误",
    503: i18n.t("index").msg.ServiceUnavailable //"服务不可用"
  }

  const msg = response.data?.message || msgMap[response.status] || "Network Error"
  Message({
    message: msg,
    type: "error",
    duration: 2500
  })

  if ([401, 403].includes(response.status) && !response.config.url.includes("logout")) {
    //server side does not distinguish 401 and 403, so recognizing both as not logged in
    store.dispatch("auth/logout")
    return Promise.reject(response)
  }

  return Promise.reject(response)
}

const handleBusinessError = res => {
  const errorMap = {
    1001: "参数验证失败",
    1002: "会话过期",
    1003: "操作频繁",

    1999: "No network" // 用户访问设备掉线， add by LC
  }
  const msgMap = {
    noUser: i18n.t("index").msg.UserNotExist,
    passwordError: i18n.t("index").msg.WrongPassword,
    noActivate: i18n.t("index").msg.NotActivate,
    failed: i18n.t("index").msg.FailedRetry
  }
  // Message.error(errorMap[res.code] || res.msg || "Backend Error")

  const msg = msgMap[res.msg] || i18n.t("index").msg.FailedRetry || "Backend Error"
  Message({
    message: msg,
    type: "error",
    duration: 2500
  })

  return Promise.reject(res)
}

const handleNetworkError = error => {
  if (error.message.includes("timeout")) {
    Message.error(i18n.t("index").msg.NetworkTimeout || "Network Timeout")
  } else {
    Message.error(i18n.t("index").msg.NetworkError || "Network Error")
  }
}

// 掉线后处理
const handleOfflineProcess = res => {
  if (res.status === 1999) {
    store.commit("UPDATE_LOADING", false)
    store.commit("UPDATE_OfflineShow", true)
    return true
  }
  return false
}

export default service



// WEBPACK FOOTER //
// ./src/utils/service.js